import { chatApi } from "@/api"
import { useState } from "react"

export const useFolders = () => {

    const [folders, setFolders] = useState([])
    const [loadingFolders, setLoadingFolders] = useState(false)
    const [loadedFolders, setLoadedFolders] = useState(false)
    const getFolders = () => {
        setLoadingFolders(true)
        return chatApi.getChatFolders()
            .then(({data}) => {
                if(data?.status === 'success'){
                    const nextFolders = Array.isArray(data?.data) ? data?.data : []
                    setFolders(nextFolders.map((folder) => ({ ...folder, id: String(folder.id) })))
                    setLoadedFolders(true)
                }
                else{
                    setFolders([])
                }
            })
            .finally(() => setLoadingFolders(false))
    }

    return {
        folders,
        getFolders,
        loadingFolders,
        loadedFolders
    }
}
